import type { ReactNode } from "react";
import { usePresenter } from "./context";
import { pad2 } from "./model";

/** Eyebrow ("04 · WHAT MAKES AN AGENT"), slide title and lead, at the prototype's positions. */
export function SlideHeading({ blockId, title, lead }: { blockId: string; title: string; lead?: ReactNode }) {
  const entry = usePresenter().model.blocks.get(blockId);
  return (
    <>
      {entry && (
        <div className="abs eyebrow slide-eyebrow">
          {pad2(entry.sectionNumber)} · {entry.section.title}
        </div>
      )}
      <h2 className="abs slide-title" style={{ margin: 0 }}>
        {title}
      </h2>
      {lead && <div className="abs slide-lead">{lead}</div>}
    </>
  );
}
